import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function requestOrganizationById(id) {
  const query = `query requestOrganizaionById(
    $id: ID
  ) {
      organization(id: $id) {
          name
          cageCode
          iconStatus
        
      }
    }`;

  const variables = { id };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });

  return response;
}

export async function organizationByCage(cageCode) {
  // Format Query
  const query = `query organizationInDB(
    $cageCode: String
  ) {
    organizationInDB(cageCode: $cageCode) {
      id
      name
      address2
      address3
      zipCode
      pointOfContact
      phoneNumber
      organizationType
      cageCode
      iconStatus
      users {name phoneNumber email role id organizationId auth0Id iconStatus } 
      
      }
    }`;

  const variables = { cageCode };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/pages/SuperAdminHome/graphql.js